import api from '../utils/api'

export const createFeedback = async (feedback) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            description: feedback.description,
        }

        const data = await api.post('/feedbacks/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        return null        
    }

}

export const updateFeedback = async (feedbackId, body) => {

    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.patch(`/feedbacks/${feedbackId}`, body).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        return null
        
    }
}

export const getFeedbackById = async (feedbackId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/feedbacks/${feedbackId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        return null        
    }
}

export const getFeedbacks = async (filter) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(filter ? `/feedbacks${filter}`:`/feedbacks`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }
}

const FeedbackService = {
    
    createFeedback,
    updateFeedback,
    getFeedbacks,
    getFeedbackById,
    
  };
  
  export default FeedbackService;